var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasTrustedShops)?_c('a',{staticClass:"trusted_shops_image d-block",attrs:{"href":_vm.href,"rel":"nofollow"}},[_c('img',{attrs:{"src":_vm.src,"width":"190","height":"191","loading":"lazy","alt":"Trusted Shops"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }